export default "__VITE_ASSET__fe950381__"